import { Pipe, PipeTransform } from "@angular/core";
import { ReportDataContext } from '@core/data/types/advanced-report';
import { TableMetaData } from "@core/data/types/Reports/report-tables"
import { SampleType } from '@library';
import * as moment from 'moment';

@Pipe({
    name: 'descTableRow',
})
export class DescribeTableRowPipe implements PipeTransform {
    constructor() {}

    transform(meta: TableMetaData, context: ReportDataContext) {
        let desc = '';

        if (context === ReportDataContext.CULTIVAR) {
            desc += `Cultivar: ${meta.ref}\n`;
            desc += `Crop: ${meta.scionCrop}`;
        }

        if (context === ReportDataContext.SITE) {
            desc += `Site: ${meta.ref}\n`;
            desc += `Location: ${meta.site}, ${meta.block}\n`;
        }

        if (context === ReportDataContext.SAMPLE) {
            desc += `Sample: ${meta.ref}\n`;
            desc += `Type: ${meta.sampleType} Sample\n`;
            desc += `${this.describeBirthDate(meta)}`
            desc += `${this.describePlantSample(meta)}`

            desc += `Location: ${meta.site}, ${meta.block}\n`;
            desc += `Scion Cultivar: ${meta.scionCultivar}\n`;
            desc += `Scion Crop: ${meta.scionCrop}\n`;

            if (meta.rootstockCultivar) {
                desc += `Rootstock Cultivar: ${meta.rootstockCultivar}\n`;
                desc += `Rootstock Crop: ${meta.rootstockCrop}\n`;
            }
        }

        if (context === ReportDataContext.EVALUATION) {
            desc += `Evaluation: ${meta.ref}\n`;
            desc += `Week ${moment(meta.evalStartDate).format('w, YYYY, Do MMMM').toString()}\n`;
            desc += `Sample: ${meta.sample}\n`;
            desc += `${this.describeBirthDate(meta)}`
            desc += `${this.describePlantSample(meta)}`
            desc += `Location: ${meta.site}, ${meta.block}\n`;
            desc += `Scion Cultivar: ${meta.scionCultivar}\n`;
            desc += `Scion Crop: ${meta.scionCrop}\n`;

            if (meta.rootstockCultivar) {
                desc += `Rootstock Cultivar: ${meta.rootstockCultivar}\n`;
                desc += `Rootstock Crop: ${meta.rootstockCrop}\n`;
            }
        }

        return desc;
    }

    describeBirthDate(meta: TableMetaData) {
        if (meta.sampleType.toLowerCase() === SampleType.PLANT) {
            return `Planted Year: ${moment(meta.birthDate).format('YYYY')}\n`;
        }

        return `Harvest Date: ${moment(meta.birthDate).format('w, YYYY, Do MMMM').toString()}\n`;
    }

    describePlantSample(meta: TableMetaData) {
        if (!meta.plantSample) return '';

        let sampleInfo = '';

        sampleInfo += `Plant Sample: ${meta.plantSample}\n`;
        sampleInfo += `Planted Year: ${moment(meta.plantSampleDate).format('YYYY')}\n`

        return sampleInfo;
    }
}